import { TaxCertificateFilterColumn } from '../types';

export const TaxCertificateListFilter: TaxCertificateFilterColumn[] = [
  {
    name: 'ID',
    value: 'id'
  },
  {
    name: 'Supplier Name',
    value: 'supplier_name'
  },
  {
    name: 'Period From',
    value: 'period_from'
  },
  {
    name: 'Period To',
    value: 'period_to'
  },
  {
    name: 'Created At',
    value: 'created_at'
  }
];
